import RealEstateCommissionInstallmentsAPI from 'dashboard/api/realEstateCommissionInstallments';
import { installmentErrorMessage } from './realEstateCommissionInstallmentData';

export function useRealEstateCommissionInstallmentWorkflow({
  apply,
  canDownload,
  canEdit,
  canRevise,
  canSend,
  downloading,
  error,
  id,
  installment,
  loadCatalog,
  notify,
  notifyError,
  optionistReportExceeds,
  revising,
  save,
  sending,
  t,
}) {
  const send = async () => {
    if (optionistReportExceeds.value) {
      error.value = t(
        'REAL_ESTATE_COMMISSION_INSTALLMENT.ERRORS.OPTIONIST_REPORT'
      );
      return null;
    }
    if (!canSend.value) {
      error.value = t('REAL_ESTATE_COMMISSION_INSTALLMENT.ERRORS.TOTALS');
      return null;
    }

    const saved = await save({ silent: true });
    if (!saved) return null;

    sending.value = true;
    try {
      const response = await RealEstateCommissionInstallmentsAPI.sendSheet(
        id.value
      );
      apply(response.data?.data || installment.value);
      notify(t('REAL_ESTATE_COMMISSION_INSTALLMENT.ALERTS.SENT'), null, {
        variant: 'success',
      });
      return installment.value;
    } catch (requestError) {
      notifyError(
        requestError,
        t('REAL_ESTATE_COMMISSION_INSTALLMENT.ERRORS.SEND')
      );
      return null;
    } finally {
      sending.value = false;
    }
  };

  const startRevision = async ({ silent = false } = {}) => {
    if (!id.value || revising.value) return null;
    if (!canRevise.value) return installment.value;

    revising.value = true;
    try {
      const response = await RealEstateCommissionInstallmentsAPI.reviseSheet(
        id.value
      );
      apply(response.data?.data || installment.value);
      if (canEdit.value) await loadCatalog();
      return installment.value;
    } catch (requestError) {
      if (silent) {
        error.value = installmentErrorMessage(
          requestError,
          t('REAL_ESTATE_COMMISSION_INSTALLMENT.ERRORS.LOAD')
        );
      } else {
        notifyError(requestError);
      }
      return null;
    } finally {
      revising.value = false;
    }
  };

  const download = async () => {
    if (!canDownload.value) return null;

    downloading.value = true;
    try {
      const response = await RealEstateCommissionInstallmentsAPI.download(
        id.value
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.download = `Planilha - ${installment.value?.dados_processo?.logradouro || id.value}.pdf`;
      link.click();
      window.URL.revokeObjectURL(url);
      return true;
    } catch (requestError) {
      notifyError(
        requestError,
        t('REAL_ESTATE_COMMISSION_INSTALLMENT.ERRORS.DOWNLOAD')
      );
      return null;
    } finally {
      downloading.value = false;
    }
  };

  return { download, send, startRevision };
}
